import {useContext, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import {client} from "@/client"
import {bearerToken, emptyUser, GlobalContext, removeBearerToken} from "@/auth";

export const Logout = () => {
  const navigate = useNavigate();

  const {globalState, setGlobalState} = useContext(GlobalContext);
  useEffect(() => {
    (async () => {
      const resp = await client.logout({bearerToken: bearerToken()});
      setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})

      if (!resp.currentUser) {
        removeBearerToken()
        navigate("/login")
      }
    })();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <h2>Logout</h2>
    </div>
  );
}
